import { CodetableListState } from './list/types-store';
import { IndicatorFactorsItemState } from './item/types-store';
import { TextCollection } from 'app/types-shared';
import { CodeItemCodesAccess } from 'app/area/indicator-factors/item/types';

export enum CodeFieldWireKey {
  code = 'code',
  node = 'node',
  class = 'class',
  category = 'category',
  defaultUomType = 'defaultUomType',
  substance = 'substance',
  substanceCategory = 'substanceCategory',
  substanceUom = 'substanceUom',
  indicatorSubstanceUom = 'indicatorSubstanceUom',
  indicatorType = 'indicatorType',
  indicatorSubstance = 'indicatorSubstance',
  indicatorSubstanceCategory = 'indicatorSubstanceCategory',
  uomTypeIndicator = 'uomTypeIndicator',
  factor = 'factor',
  comments = 'comments',
  validFrom = 'validFrom',
  location = 'location',
  unit = 'unit',
  source = 'source',
  equipment = 'equipment'
}

export interface CodeFieldWire {
  id: number;
  searchRequired: boolean;
}

export type CodeFieldsWire = { [key in keyof typeof CodeFieldWireKey]: CodeFieldWire; };

export enum CodeFieldFlagWireKey {
  substance = 'substance',
  indicatorSubstance = 'indicatorSubstance',
  substanceCategory = 'substanceCategory',
  indicatorSubstanceCategory = 'indicatorSubstanceCategory',
  indicatorSubstanceUom = 'indicatorSubstanceUom',
  substanceUom = 'substanceUom',
  indicatorType = 'indicatorType',
  factor = 'factor',
  comments = 'comments',
  validFrom = 'validFrom',
  location = 'location',
  unit = 'unit',
  source = 'source',
  equipment = 'equipment'
}

export type CodeFieldFlagsWire = { [key in keyof typeof CodeFieldFlagWireKey]: boolean; };

export type CodetablesAccessWire = AccessCodetables[];
export type CodesAccessWire = CodeItemCodesAccess[];

export type CodeLanguageField = {
  description: boolean;
  longDescription: boolean;
};

export type CodeFieldIncludeInactive = {
  enabled: boolean;
};

export enum CodeFieldIncludeInactiveKey {
  active = 'active',
  all = 'all'
}

export type CodeFieldIncludeInactiveValues = { [key in keyof typeof CodeFieldIncludeInactiveKey]: CodeFieldIncludeInactive; };

export interface CodeMetadataWire extends CodeFieldsWire {
  formName: string;
  label: string;
  minLevel?: number;
  language: CodeLanguageField;
}

export interface CodeField {
  id: number;
  searchRequired: boolean;
}

export interface CodetableMetadata {
  formName: string;
  codetable: CodeField;
  codetableClass: CodeField;
  label: string;
  codetableNode: CodeField;
  codetableCategory: CodeField;
  equipment?: boolean;
  location?: boolean;
  unit?: boolean;
  source?: boolean;
}

export interface AccessCodetables {
  id: number;
  create: boolean;
  administrationCentral: boolean;
}

export interface AccessCodes {
  id: number;
  edit: boolean;
  delete: boolean;
  move: boolean;
}

export interface CodetableAccess {
  codetables: AccessCodetables;
  codes: AccessCodes;
}

export interface CodetableAccessState {
  fetchingCodetables: number;
  fetchingCodes: number;
  data: CodetableAccess;
}

export interface CodetableMetadataState {
  fetching: number;
  data: CodetableMetadata;
}

export interface CodetableAdministrationState {
  metadata: CodetableMetadataState;
  access: CodetableAccessState;
  list: CodetableListState;
  item: IndicatorFactorsItemState;
  texts: TextCollection;
}
